import styled from "styled-components";

export const TextContainer = styled.div`
  max-width: 1174px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 490;
  width: 100%;

  span {
    font-weight: 500;
    font-size: 15px;
    line-height: 30px;
    color: #fff;
  }

  h1 {
    margin-top: 23px;
    font-weight: 400;
    font-size: 92px;
    line-height: 86px;
    color: #fff;
    width: 400px;
    letter-spacing: -0.06em;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      font-weight: 400;
      font-size: 62px;
      line-height: 50px;
    }

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      font-size: 54px;
      width: 100%;
      margin: auto;
      text-align: center;
    }

    img {
      margin-left: 20px;
    }
  }

  p {
    margin-top: 50px;
    font-weight: 300;
    font-size: 20px;
    line-height: 28px;
    width: 600px;
    color: #fff;

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      font-weight: 300;
      font-size: 14px;
      line-height: 20px;
      width: 100%;
    }

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      h1 {
        font-size: 54px;
        width: 100%;
        margin: auto;
        text-align: center;
      }
      p {
        text-align: center;
        margin: auto;
      }
    }
  }
`;

export const ButtonsContainer = styled.div`
  margin-top: 36px;

  button {
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      width: 100%;
    }

    svg {
      margin-left: 10px;
    }
    a {
      color: #fff;
    }

    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      margin-top: 30px;
    }
  }
  button:not(:first-child) {
    margin-left: 30px;
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      margin-left: 0px;
    }
  }
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const ImageContainer = styled.div`
  position: absolute;
  top: -150px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
      left: 50%;
      width: 100%;
      height: 50%;
    }
    @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
      width: 100%;
      height: 100%;
      transform: scale(2);
    }
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    left: -30%;
    top: -400px;
  }
  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.mobile} {
    left: -30%;
    top: -200px;
  }
`;